import { EarningsInsight } from '@api/api/earnings-insights';

export const parseEarningsInsights = (insights: EarningsInsight[]) => {
  const hasEarningsInsights = insights.length > 0;
  let earningsInsight = undefined;

  if (hasEarningsInsights) {
    const previewInsight = insights.find(insight => insight.type === 'preview');
    const recapInsight = insights.find(insight => insight.type === 'recap');
    earningsInsight = recapInsight ?? previewInsight;
  }

  return earningsInsight;
};

export const deduplicateEarningsInsights = (
  insights: EarningsInsight[]
): EarningsInsight[] => {
  const groupedByEarningsId = new Map<string, EarningsInsight[]>();

  insights.forEach(insight => {
    const earningsId = insight.earnings_id;

    if (!groupedByEarningsId.has(earningsId)) {
      groupedByEarningsId.set(earningsId, []);
    }

    const group = groupedByEarningsId.get(earningsId);

    if (group) {
      group.push(insight);
    }
  });

  const deduplicated: EarningsInsight[] = [];

  groupedByEarningsId.forEach(groupedInsights => {
    const parsedEarningsInsight = parseEarningsInsights(groupedInsights);

    if (parsedEarningsInsight) {
      deduplicated.push(parsedEarningsInsight);
    }
  });

  return deduplicated;
};
